import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/SignUp.css";
import axios from "axios";
import Footer from "./Footer";
import Header from "./Header";
import AdLeft from "./AdLeft";
import AdRight from "./AdRight";

function SignUp() {
    const [birthDate, setBirthDate] = useState("");
    const [name, setName] = useState("");
    const [id, setId] = useState("");
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("");
    const [authNum, setAuthNum] = useState("");
    const [authCheck, setAuthCheck] = useState(false);
    const [elementBox, setElementBox] = useState(false);
    const [sameValue,setSameValue] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0); // 초 단위
    const [isExpired, setIsExpired] = useState(null);
    const [sending, setSending] = useState(false);
    const [isRequested, setIsRequested] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [showPwRule, setShowPwRule] = useState(false);

    const navigate = useNavigate();
    const handleDateChange = (e) => {
        setBirthDate(e.target.value); // 선택된 날짜를 상태로 저장
    }
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const elementToggleBox = () => {
        setElementBox(!elementBox);
    }

    const handleSignUp = (e) => {
        e.preventDefault();

        if (name === "") {
            alert("이름을 입력하세요.");
        } else if (birthDate === "") {
            alert("생년월일을 입력하세요.");
        } else if (id === "") {
            alert("아이디를 입력하세요.");
        } else if (!validatePassword(password)) {
            alert("비밀번호는 대문자, 소문자, 숫자, 특수문자를 포함하고 연속/반복 패턴 없이 8~16자로 구성해야 합니다.");
        } else if (email === "") {
            alert("이메일을 입력하세요.");
        } else if (!authCheck) {
            alert("이메일 인증을 확인해주세요");
        }
            // } else if (!isValidEmail(email)){
            //     alert("적절한 이메일 형식이 아닙니다")
        // }
        else if (!sameValue) {
            alert("아이디 중복을 체크하세요.");
        } else {
            const userData = {
                birthDate: birthDate,
                name: name,
                username: id,
                password: password,
                email: email,
            };

            const url = `${process.env.REACT_APP_SPRING_API_URL}/api/signup`;

            axios
                .post(url, userData)
                .then((response) => {
                    alert(`${id}님 회원가입 성공`);
                    navigate("/");
                })
                .catch((err) => {
                    const msg = err.response?.data || "회원가입 실패";
                    alert(msg);
                });
        }
    };

    const handleSame = (e) => {
        e.preventDefault();
        const userData = {
            username: id,
        };

        console.log("보내는 ID:", userData.username);
        axios
            .get(
                `${process.env.REACT_APP_SPRING_API_URL}/api/signup/IdCheck/${userData.username}`
            )
            .then((response) => {
                if (response.data === true) {
                    alert("사용 가능한 아이디입니다");
                    setSameValue(true);
                } else {
                    alert("중복된 아이디입니다");
                    setSameValue(false);
                }
            })
            .catch((_error) => {
                alert("적절한 값을 입력하세요");
                setSameValue(false);
            });
    };

    const handleSend = (e) => {
        e.preventDefault();
        if (!isValidEmail(email)) {
            alert("적절한 이메일 형식이 아닙니다");
            return;
        }
        if (timeLeft > 0) {
            alert("인증번호 유효시간이 남아있습니다. 잠시 후 다시 시도해주세요.");
            return;
        }

        setSending(true);
        const userData = {
            mail: email,
        };
        const url = `${process.env.REACT_APP_SPRING_API_URL}/api/mailSend`;

        axios
            .post(url, userData)
            .then((response) => {
                alert(`인증번호 발송되었습니다`);

                setTimeLeft(300);
                setIsExpired(false);
                setIsRequested(true);
            })
            .catch((err) => {
                const msg = err.response?.data;
                alert(msg);
                alert("작성하신 이메일을 다시 확인해주세요.");
            })
            .finally(() => {
                setSending(false);
            });
    };

    const handleCheck = (e) => {
        e.preventDefault();
        if (isExpired) {
            alert("인증 시간이 만료되었습니다. 다시 요청해주세요.");
            return;
        }
        axios
            .get(
                `${process.env.REACT_APP_SPRING_API_URL}/api/mailCheck?authNum=${authNum}&email=${email}`
            )
            .then((response) => {
                alert(response.data); // "인증이 완료되었습니다."
                setAuthCheck(true);
                setTimeLeft(0);
                setIsExpired(false);
            })
            .catch((err) => {
                alert(err.response?.data); // "인증 실패: 번호가 일치하지 않습니다."
                setAuthCheck(false);
            });
    };

    useEffect(() => {
        if (timeLeft <= 0) {
            setIsExpired(true);
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    // 타이머 UI 변환
    const formatTime = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };

    // 비밀번호 유효성 검사
    const validatePassword = (pw) => {
        if (pw.length < 8 || pw.length > 16) return false;

        const hasUpper = /[A-Z]/.test(pw);
        const hasLower = /[a-z]/.test(pw);
        const hasNumber = /[0-9]/.test(pw);
        const hasSpecial = /[^A-Za-z0-9]/.test(pw);

        // 동일 문자 3회 이상 반복 금지
        const repeatPattern = /(.)\1\1/;

        // 연속 패턴 금지
        const sequentialRegex =
            /(012|123|234|345|456|567|678|789|890|098|987|876|765|654|543|432|321|qwe|wer|ert|rty|tyu|yui|uio|iop|poi|oiu|iuy|uyt|ytr|tre|rew|ewq|asd|sdf|dfg|fgh|ghj|hjk|jkl|lkj|kjh|jhg|hgf|gfd|fds|dsa|zxc|xcv|cvb|vbn|bnm|mnb|nbv|bvc|vcx|cxz)/i;

        return hasUpper && hasLower && hasNumber && hasSpecial && !repeatPattern.test(pw) && !sequentialRegex.test(pw);
    };

    // 비밀번호 강도 계산 (가입 가능 기준과 동일)
    const calculateStrength = (pw) => {
        let score = 0;

        if (pw.length >= 8 && pw.length <= 16) score++;
        if (/[A-Z]/.test(pw)) score++;
        if (/[a-z]/.test(pw)) score++;
        if (/[0-9]/.test(pw)) score++;
        if (/[^A-Za-z0-9]/.test(pw)) score++;

        const repeatPattern = /(.)\1\1/;
        if (!repeatPattern.test(pw)) score++;

        const sequentialRegex =
            /(012|123|234|345|456|567|678|789|890|098|987|876|765|654|543|432|321|qwe|wer|ert|rty|tyu|yui|uio|iop|poi|oiu|iuy|uyt|ytr|tre|rew|ewq|asd|sdf|dfg|fgh|ghj|hjk|jkl|lkj|kjh|jhg|hgf|gfd|fds|dsa|zxc|xcv|cvb|vbn|bnm|mnb|nbv|bvc|vcx|cxz)/i;
        if (!sequentialRegex.test(pw)) score++;

        return score; // 최대 7점
    };

    // 강도 표시를 가입 가능 기준과 일치시키기
    const getStrengthLabel = (score) => {
        if (score < 6) return "약함";
        if (score === 6) return "보통";
        if (score === 7) return "강함";
    };

    return (
        <div className="SignUp">
            <Header />
            {/* 좌측 광고 */}
            <div className="AdLeft-container">
                <AdLeft />
            </div>
            {/* 우측 광고 */}
            <div className="AdRight-container">
                <AdRight />
            </div>
            <header className="SignUp-header">

                <div className="SignUp-location-container">
                    <div className="SignUp-location-element">
                        <div className="SignUp-location">
                            <button className="SignUp-location-button" type="button"
                                    onClick={() => navigate("/")}>홈
                            </button>
                        </div>
                        <div className="SignUp-location-down"></div>
                        <div className="SignUp-location">
                            <button className="SignUp-location-button" type="button"
                                    onClick={() => navigate("/login")}>로그인
                            </button>
                        </div>
                        <div className="SignUp-location-down"></div>
                        <div className="SignUp-location">
                            <button className="SignUp-Box-element" onClick={elementToggleBox}>회원가입</button>
                        </div>

                        {elementBox && (
                            <div className="SignUp-Box" id="myBox">
                                <button className="SignUp-Box-element" onClick={() => {
                                    setElementBox(false);
                                    navigate("/idfind")}}>아이디 찾기
                                </button>
                                <button className="SignUp-Box-element" onClick={() => {
                                    setElementBox(false);
                                    navigate("/pwfind")}}>비밀번호 찾기
                                </button>
                                <button className="SignUp-Box-element" onClick={() => {
                                    setElementBox(false);
                                    navigate("/signup")}}>회원가입
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="SignUp-container">
                    <div className="SignUp-container-element">
                        <div className="SignUp-element-container">
                            <p className="SignUp-element-box">이름</p>
                            <input
                                className="SignUp-textbox"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="이름 입력"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSignUp(e); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />
                            <p className="SignUp-element-box">생년월일</p>
                            <input
                                className="SignUp-textbox"
                                type="date"
                                id="startDate"
                                value={birthDate}
                                onChange={handleDateChange}
                                max="9999-12-31"
                            />
                        </div>
                        <div className="SignUp-element-container">
                            <p className="SignUp-element-box">아이디</p>
                            <input
                                className="SignUp-textbox"
                                type="text"
                                value={id}
                                onChange={(e) => {
                                    setId(e.target.value);
                                    setSameValue(false);
                                }}
                                placeholder="아이디 입력"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSignUp(e); // ✅ 엔터로 검색 실행
                                    }
                                }}
                            />
                            <div className="SignUp-same-box">
                                <button
                                    className="SignUp-same-button"
                                    onClick={handleSame}
                                    style={{
                                        backgroundColor: sameValue ? "gray" : "darkblue",
                                        color: "white",
                                        cursor: sameValue ? "not-allowed" : "pointer"
                                    }}
                                    disabled={sameValue} // 이미 중복확인 끝났으면 비활성화
                                >
                                    {sameValue ? "확인 완료" : "중복확인"}
                                </button>
                            </div>
                        </div>

                        <div className="SignUp-element-container">
                            <p className="SignUp-element-box">비밀번호</p>
                            <input
                                className="SignUp-textbox"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setPassword(value);
                                    setPasswordStrength(calculateStrength(value));
                                }}
                                minLength="8"
                                maxLength="16"
                                placeholder="비밀번호 입력"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSignUp(e);
                                    }
                                }}
                            />
                            <div className="SignUp-auth-box">
                                <button
                                    className="SignUp-auth-button"
                                    onClick={() => setShowPassword(prev => !prev)}
                                    type="button"
                                >
                                    {showPassword ? "숨기기" : "표시"}
                                </button>
                            </div>
                            <div className="SignUp-auth-box">
                                <button
                                    className="SignUp-auth-button"
                                    type="button"
                                    onClick={() => setShowPwRule(prev => !prev)}
                                >
                                    {showPwRule ? "닫기" : "비밀번호 설명"}
                                </button>
                            </div>
                            {showPwRule && (
                                <div className="pw-rule-box">
                                    <ul>
                                        <li>✔ 8~16자 입력</li>
                                        <li>✔ 대문자 포함 (A~Z)</li>
                                        <li>✔ 소문자 포함 (a~z)</li>
                                        <li>✔ 숫자 포함 (0~9)</li>
                                        <li>✔ 특수문자 포함 (! @ # 등)</li>
                                        <li>❌ 동일 문자 3회 반복 금지</li>
                                        <li>❌ 연속 패턴 금지</li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div className="SignUp-element-container">
                            <p className="SignUp-element-box">비밀번호 강도</p>

                            <div className="strength-bar">
                                <div
                                    className="strength-fill"
                                    style={{
                                        width: `${(passwordStrength / 7) * 100}%`,
                                        backgroundColor:
                                            passwordStrength < 3
                                                ? "red"
                                                : passwordStrength < 5
                                                    ? "orange"
                                                    : "green",
                                    }}
                                ></div>
                            </div>

                            <p className="strength-text">
                                {passwordStrength < 3
                                    ? "약함"
                                    : passwordStrength < 5
                                        ? "보통"
                                        : "강함"}
                            </p>
                        </div>

                        <div className="SignUp-element-container">
                            <p className="SignUp-element-box">이메일</p>
                            <input className="SignUp-textbox"
                                   type="email"
                                   value={email}
                                   onChange={(e) => setEmail(e.target.value)}
                                   placeholder="example@example.com"
                                   onKeyDown={(e) => {
                                       if (e.key === "Enter") {
                                           handleSignUp(e); // ✅ 엔터로 검색 실행
                                       }
                                   }}
                            />
                            <div className="SignUp-auth-box">
                                <button className="SignUp-auth-button" onClick={handleSend} disabled={sending}>
                                    {sending ? "전송 중..." : "인증번호 전송"}
                                </button>
                            </div>
                            {timeLeft > 0 && !authCheck && <p className="SignUp-timer">남은 시간: {formatTime(timeLeft)}</p>}
                        </div>

                        <div className="SignUp-element-container">
                            <p className="SignUp-element-box">인증번호</p>
                            <input className="SignUp-textbox"
                                   type="text"
                                   value={authNum}
                                   onChange={(e) => setAuthNum(e.target.value)}
                                   placeholder="인증번호 입력"
                                   onKeyDown={(e) => {
                                       if (e.key === "Enter") {
                                           handleSignUp(e); // ✅ 엔터로 검색 실행
                                       }
                                   }}
                            />
                            <div className="SignUp-same-box">
                                <button
                                    className="SignUp-same-button"
                                    onClick={handleCheck}
                                    disabled={authCheck}
                                >
                                    {authCheck ? "확인 완료" : "확인"}
                                </button>
                                {!authCheck && isExpired && isRequested && (
                                    <p style={{ color: "red" }}>인증 시간이 만료되었습니다. 다시 요청해주세요.</p>
                                )}
                            </div>
                        </div>

                        {(name === "" || id === "" || password === "" || birthDate === "" || email === "" || authNum === "") ? (
                            <div className="SignUp-container-signup">
                                <button
                                    className="Sign-up-button"
                                    onClick={handleSignUp}
                                    style={{background: "gray"}}
                                >
                                    회원가입
                                </button>
                            </div>
                        ) : (
                            <div className="SignUp-container-signup">
                                <button
                                    className="Sign-up-button"
                                    onClick={handleSignUp}
                                    style={{background: "darkblue"}}
                                >
                                    회원가입
                                </button>
                            </div>
                        )}

                    </div>
                </div>

            </header>
            <Footer />
        </div>
    );
}

export default SignUp;